<section class="technologies-section" [dir]="lang.getDir()">
  <div class="container">
    <h2 class="section-title animate-slide-in">
      {{ 'tech.title' | translate }}
    </h2>

    <div class="tech-grid">
      <div class="tech-card animate-fade-in" *ngFor="let tech of techList">
        <div class="tech-card-inner">
          <div class="tech-icon">
            <img [src]="tech.logo" [alt]="tech.name" />
          </div>
          <div class="tech-label">
            {{ tech.label | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
